import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import AdminDashboard from './components/AdminDashboard';
import DemoAssessment from './components/DemoAssessment';
import ProctoringWidgetDemo from './components/ProctoringWidgetDemo';
import ViolationUatPage from './pages/ViolationUatPage';
import FaceLogin from './components/FaceLogin';
import RegistrationPage from './components/RegistrationPage';
import { SecureExamGate } from './security';
import { TenantAuthProvider } from './context/TenantAuthContext';
import { PlatformAuthProvider } from './context/PlatformAuthContext';
import TenantLogin from './tenant/TenantLogin';
import TenantLayout from './tenant/TenantLayout';
import TenantDashboard from './tenant/TenantDashboard';
import TenantUsersListPage from './tenant/TenantUsersListPage';
import TenantUserDetailPage from './tenant/TenantUserDetailPage';
import TenantUserFormPage from './tenant/TenantUserFormPage';
import TenantRolesListPage from './tenant/TenantRolesListPage';
import TenantRoleDetailPage from './tenant/TenantRoleDetailPage';
import TenantRoleFormPage from './tenant/TenantRoleFormPage';
import TenantRolePermissionMatrixPage from './tenant/TenantRolePermissionMatrixPage';
import TenantSettingsPage from './tenant/TenantSettingsPage';
import TenantAuditPage from './tenant/TenantAuditPage';
import TenantAuditLogDetailPage from './tenant/TenantAuditLogDetailPage';
import TenantSessionsListPage from './tenant/TenantSessionsListPage';
import TenantSessionDetailPage from './tenant/TenantSessionDetailPage';
import TenantAnalyticsPage from './tenant/TenantAnalyticsPage';
import PlatformLogin from './platform/PlatformLogin';
import PlatformLayout from './platform/PlatformLayout';
import PlatformAnalyticsPage from './platform/PlatformAnalyticsPage';
import PlatformPlansListPage from './platform/PlatformPlansListPage';
import PlatformPlanFormPage from './platform/PlatformPlanFormPage';
import PlatformPlanDetailPage from './platform/PlatformPlanDetailPage';
import PlatformTenantsListPage from './platform/PlatformTenantsListPage';
import PlatformTenantFormPage from './platform/PlatformTenantFormPage';
import PlatformTenantDetailPage from './platform/PlatformTenantDetailPage';
import PlatformTenantSettingsListPage from './platform/PlatformTenantSettingsListPage';
import PlatformTenantSettingDetailPage from './platform/PlatformTenantSettingDetailPage';
import PlatformTenantSettingFormPage from './platform/PlatformTenantSettingFormPage';
import PlatformTenantUsersListPage from './platform/PlatformTenantUsersListPage';
import PlatformTenantUserDetailPage from './platform/PlatformTenantUserDetailPage';
import PlatformTenantRolesListPage from './platform/PlatformTenantRolesListPage';
import PlatformTenantRoleDetailPage from './platform/PlatformTenantRoleDetailPage';
import PlatformPermissionsListPage from './platform/PlatformPermissionsListPage';
import PlatformPermissionDetailPage from './platform/PlatformPermissionDetailPage';
import PlatformPermissionFormPage from './platform/PlatformPermissionFormPage';
import PlatformApiKeysListPage from './platform/PlatformApiKeysListPage';
import PlatformApiKeyDetailPage from './platform/PlatformApiKeyDetailPage';
import PlatformUsagePoliciesListPage from './platform/PlatformUsagePoliciesListPage';
import PlatformUsagePolicyDetailPage from './platform/PlatformUsagePolicyDetailPage';
import PlatformUsagePolicyFormPage from './platform/PlatformUsagePolicyFormPage';
import PlatformTenantSubscriptionsListPage from './platform/PlatformTenantSubscriptionsListPage';
import PlatformTenantSubscriptionDetailPage from './platform/PlatformTenantSubscriptionDetailPage';
import PlatformTenantSubscriptionFormPage from './platform/PlatformTenantSubscriptionFormPage';
import PlatformFeatureFlagsListPage from './platform/PlatformFeatureFlagsListPage';
import PlatformFeatureFlagDetailPage from './platform/PlatformFeatureFlagDetailPage';
import PlatformFeatureFlagFormPage from './platform/PlatformFeatureFlagFormPage';
import PlatformAuditLogsListPage from './platform/PlatformAuditLogsListPage';
import PlatformAuditLogDetailPage from './platform/PlatformAuditLogDetailPage';
import PlatformLoginSessionsListPage from './platform/PlatformLoginSessionsListPage';
import PlatformLoginSessionDetailPage from './platform/PlatformLoginSessionDetailPage';
import PlatformSupportTicketsListPage from './platform/PlatformSupportTicketsListPage';
import PlatformSupportTicketDetailPage from './platform/PlatformSupportTicketDetailPage';
import PlatformSystemSettingsListPage from './platform/PlatformSystemSettingsListPage';
import PlatformSystemSettingDetailPage from './platform/PlatformSystemSettingDetailPage';
import PlatformSystemSettingFormPage from './platform/PlatformSystemSettingFormPage';
import PlatformWebhooksListPage from './platform/PlatformWebhooksListPage';
import PlatformWebhookDetailPage from './platform/PlatformWebhookDetailPage';
import PlatformWebhookFormPage from './platform/PlatformWebhookFormPage';
import PlatformExportJobsListPage from './platform/PlatformExportJobsListPage';
import PlatformExportJobDetailPage from './platform/PlatformExportJobDetailPage';
import PlatformExportJobFormPage from './platform/PlatformExportJobFormPage';
import TenantPlansPage from './tenant/TenantPlansPage';
import TenantPlanDetailPage from './tenant/TenantPlanDetailPage';
import TenantPermissionsPage from './tenant/TenantPermissionsPage';
import TenantApiKeysListPage from './tenant/TenantApiKeysListPage';
import TenantApiKeyCreatePage from './tenant/TenantApiKeyCreatePage';
import TenantApiKeyDetailPage from './tenant/TenantApiKeyDetailPage';
import TenantUsagePolicyPage from './tenant/TenantUsagePolicyPage';
import TenantSubscriptionPage from './tenant/TenantSubscriptionPage';
import TenantFeaturesPage from './tenant/TenantFeaturesPage';
import TenantSupportTicketsListPage from './tenant/TenantSupportTicketsListPage';
import TenantSupportTicketFormPage from './tenant/TenantSupportTicketFormPage';
import TenantSupportTicketDetailPage from './tenant/TenantSupportTicketDetailPage';
import TenantSystemSettingsListPage from './tenant/TenantSystemSettingsListPage';
import TenantSystemSettingDetailPage from './tenant/TenantSystemSettingDetailPage';
import TenantSystemSettingFormPage from './tenant/TenantSystemSettingFormPage';
import TenantWebhooksListPage from './tenant/TenantWebhooksListPage';
import TenantWebhookDetailPage from './tenant/TenantWebhookDetailPage';
import TenantWebhookFormPage from './tenant/TenantWebhookFormPage';
import TenantExportJobsListPage from './tenant/TenantExportJobsListPage';
import TenantExportJobDetailPage from './tenant/TenantExportJobDetailPage';
import TenantExportJobFormPage from './tenant/TenantExportJobFormPage';
import TenantBillingLayout from './tenant/TenantBillingLayout';
import TenantBillingProfilePage from './tenant/TenantBillingProfilePage';
import TenantInvoicesListPage from './tenant/TenantInvoicesListPage';
import TenantInvoiceDetailPage from './tenant/TenantInvoiceDetailPage';
import PlatformBillingLayout from './platform/PlatformBillingLayout';
import PlatformBillingProfilesListPage from './platform/PlatformBillingProfilesListPage';
import PlatformBillingProfileFormPage from './platform/PlatformBillingProfileFormPage';
import PlatformBillingInvoicesListPage from './platform/PlatformBillingInvoicesListPage';
import PlatformBillingInvoiceDetailPage from './platform/PlatformBillingInvoiceDetailPage';
import PlatformBillingInvoiceFormPage from './platform/PlatformBillingInvoiceFormPage';
import TenantKnowledgeBaseLayout from './tenant/TenantKnowledgeBaseLayout';
import TenantKnowledgeArticlesListPage from './tenant/TenantKnowledgeArticlesListPage';
import TenantKnowledgeArticleFormPage from './tenant/TenantKnowledgeArticleFormPage';
import TenantKnowledgeArticleDetailPage from './tenant/TenantKnowledgeArticleDetailPage';
import PlatformKnowledgeArticlesListPage from './platform/PlatformKnowledgeArticlesListPage';
import PlatformKnowledgeArticleFormPage from './platform/PlatformKnowledgeArticleFormPage';
import PlatformKnowledgeArticleDetailPage from './platform/PlatformKnowledgeArticleDetailPage';
import TenantNotificationTemplatesLayout from './tenant/TenantNotificationTemplatesLayout';
import TenantNotificationTemplatesListPage from './tenant/TenantNotificationTemplatesListPage';
import TenantNotificationTemplateFormPage from './tenant/TenantNotificationTemplateFormPage';
import TenantNotificationTemplateDetailPage from './tenant/TenantNotificationTemplateDetailPage';
import PlatformNotificationTemplatesListPage from './platform/PlatformNotificationTemplatesListPage';
import PlatformNotificationTemplateFormPage from './platform/PlatformNotificationTemplateFormPage';
import PlatformNotificationTemplateDetailPage from './platform/PlatformNotificationTemplateDetailPage';
import TenantProfilePage from './tenant/TenantProfilePage';
import TenantDashboardConfigPage from './tenant/TenantDashboardConfigPage';
import PlatformProfilePage from './platform/PlatformProfilePage';
import PlatformDashboardConfigPage from './platform/PlatformDashboardConfigPage';

function App() {
  return (
    <Router>
      <TenantAuthProvider>
        <PlatformAuthProvider>
        <Routes>
          <Route path="/platform/login" element={<PlatformLogin />} />
          <Route path="/platform" element={<PlatformLayout />}>
            <Route path="profile" element={<PlatformProfilePage />} />
            <Route index element={<Navigate to="analytics" replace />} />
            <Route path="analytics" element={<PlatformAnalyticsPage />} />
            <Route path="dashboard-config" element={<PlatformDashboardConfigPage />} />
            <Route path="audit-logs" element={<Outlet />}>
              <Route index element={<PlatformAuditLogsListPage />} />
              <Route path=":logId" element={<PlatformAuditLogDetailPage />} />
            </Route>
            <Route path="login-sessions" element={<Outlet />}>
              <Route index element={<PlatformLoginSessionsListPage />} />
              <Route path=":sessionId" element={<PlatformLoginSessionDetailPage />} />
            </Route>
            <Route path="support-tickets" element={<Outlet />}>
              <Route index element={<PlatformSupportTicketsListPage />} />
              <Route path=":ticketId" element={<PlatformSupportTicketDetailPage />} />
            </Route>
            <Route path="system-settings" element={<Outlet />}>
              <Route index element={<PlatformSystemSettingsListPage />} />
              <Route path="new" element={<PlatformSystemSettingFormPage />} />
              <Route path=":settingId/edit" element={<PlatformSystemSettingFormPage />} />
              <Route path=":settingId" element={<PlatformSystemSettingDetailPage />} />
            </Route>
            <Route path="webhooks" element={<Outlet />}>
              <Route index element={<PlatformWebhooksListPage />} />
              <Route path="new" element={<PlatformWebhookFormPage />} />
              <Route path=":webhookId/edit" element={<PlatformWebhookFormPage />} />
              <Route path=":webhookId" element={<PlatformWebhookDetailPage />} />
            </Route>
            <Route path="export-jobs" element={<Outlet />}>
              <Route index element={<PlatformExportJobsListPage />} />
              <Route path="new" element={<PlatformExportJobFormPage />} />
              <Route path=":jobId" element={<PlatformExportJobDetailPage />} />
            </Route>
            <Route path="billing" element={<PlatformBillingLayout />}>
              <Route index element={<Navigate to="profiles" replace />} />
              <Route path="profiles" element={<PlatformBillingProfilesListPage />} />
              <Route path="profiles/new" element={<PlatformBillingProfileFormPage />} />
              <Route path="profiles/tenant/:tenantId" element={<PlatformBillingProfileFormPage />} />
              <Route path="invoices" element={<Outlet />}>
                <Route index element={<PlatformBillingInvoicesListPage />} />
                <Route path="new" element={<PlatformBillingInvoiceFormPage />} />
                <Route path=":invoiceId/edit" element={<PlatformBillingInvoiceFormPage />} />
                <Route path=":invoiceId" element={<PlatformBillingInvoiceDetailPage />} />
              </Route>
            </Route>
            <Route path="knowledge-base/articles" element={<Outlet />}>
              <Route index element={<PlatformKnowledgeArticlesListPage />} />
              <Route path="new" element={<PlatformKnowledgeArticleFormPage />} />
              <Route path=":articleId/edit" element={<PlatformKnowledgeArticleFormPage />} />
              <Route path=":articleId" element={<PlatformKnowledgeArticleDetailPage />} />
            </Route>
            <Route path="notification-templates" element={<Outlet />}>
              <Route index element={<PlatformNotificationTemplatesListPage />} />
              <Route path="new" element={<PlatformNotificationTemplateFormPage />} />
              <Route path=":templateId/edit" element={<PlatformNotificationTemplateFormPage />} />
              <Route path=":templateId" element={<PlatformNotificationTemplateDetailPage />} />
            </Route>
            <Route path="plans" element={<Outlet />}>
              <Route index element={<PlatformPlansListPage />} />
              <Route path="new" element={<PlatformPlanFormPage />} />
              <Route path=":id/edit" element={<PlatformPlanFormPage />} />
              <Route path=":id" element={<PlatformPlanDetailPage />} />
            </Route>
            <Route path="tenants" element={<Outlet />}>
              <Route index element={<PlatformTenantsListPage />} />
              <Route path="new" element={<PlatformTenantFormPage />} />
              <Route path=":id/edit" element={<PlatformTenantFormPage />} />
              <Route path=":id/tenant-settings" element={<Outlet />}>
                <Route index element={<PlatformTenantSettingsListPage />} />
                <Route path="new" element={<PlatformTenantSettingFormPage />} />
                <Route path=":settingId/edit" element={<PlatformTenantSettingFormPage />} />
                <Route path=":settingId" element={<PlatformTenantSettingDetailPage />} />
              </Route>
              <Route path=":id" element={<PlatformTenantDetailPage />} />
            </Route>
            <Route path="tenant-subscriptions" element={<Outlet />}>
              <Route index element={<PlatformTenantSubscriptionsListPage />} />
              <Route path="new" element={<PlatformTenantSubscriptionFormPage />} />
              <Route path=":id/edit" element={<PlatformTenantSubscriptionFormPage />} />
              <Route path=":id" element={<PlatformTenantSubscriptionDetailPage />} />
            </Route>
            <Route path="tenant-users" element={<Outlet />}>
              <Route index element={<PlatformTenantUsersListPage />} />
              <Route path=":id" element={<PlatformTenantUserDetailPage />} />
            </Route>
            <Route path="api-keys" element={<Outlet />}>
              <Route index element={<PlatformApiKeysListPage />} />
              <Route path=":id" element={<PlatformApiKeyDetailPage />} />
            </Route>
            <Route path="usage-policies" element={<Outlet />}>
              <Route index element={<PlatformUsagePoliciesListPage />} />
              <Route path="new" element={<PlatformUsagePolicyFormPage />} />
              <Route path=":id/edit" element={<PlatformUsagePolicyFormPage />} />
              <Route path=":id" element={<PlatformUsagePolicyDetailPage />} />
            </Route>
            <Route path="feature-flags" element={<Outlet />}>
              <Route index element={<PlatformFeatureFlagsListPage />} />
              <Route path="new" element={<PlatformFeatureFlagFormPage />} />
              <Route path=":id/edit" element={<PlatformFeatureFlagFormPage />} />
              <Route path=":id" element={<PlatformFeatureFlagDetailPage />} />
            </Route>
            <Route path="tenant-roles" element={<Outlet />}>
              <Route index element={<PlatformTenantRolesListPage />} />
              <Route path=":id" element={<PlatformTenantRoleDetailPage />} />
            </Route>
            <Route path="permissions" element={<Outlet />}>
              <Route index element={<PlatformPermissionsListPage />} />
              <Route path="new" element={<PlatformPermissionFormPage />} />
              <Route path=":id/edit" element={<PlatformPermissionFormPage />} />
              <Route path=":id" element={<PlatformPermissionDetailPage />} />
            </Route>
          </Route>
          <Route path="/tenant/login" element={<TenantLogin />} />
          <Route path="/tenant" element={<TenantLayout />}>
            <Route path="profile" element={<TenantProfilePage />} />
            <Route path="dashboard-config" element={<TenantDashboardConfigPage />} />
            <Route index element={<TenantDashboard />} />
            <Route path="analytics" element={<TenantAnalyticsPage />} />
            <Route path="usage-policy" element={<TenantUsagePolicyPage />} />
            <Route path="users" element={<Outlet />}>
              <Route index element={<TenantUsersListPage />} />
              <Route path="new" element={<TenantUserFormPage />} />
              <Route path=":userId/edit" element={<TenantUserFormPage />} />
              <Route path=":userId" element={<TenantUserDetailPage />} />
            </Route>
            <Route path="roles" element={<Outlet />}>
              <Route index element={<TenantRolesListPage />} />
              <Route path="new" element={<TenantRoleFormPage />} />
              <Route path=":roleId/permissions" element={<TenantRolePermissionMatrixPage />} />
              <Route path=":roleId/edit" element={<TenantRoleFormPage />} />
              <Route path=":roleId" element={<TenantRoleDetailPage />} />
            </Route>
            <Route path="api-keys" element={<Outlet />}>
              <Route index element={<TenantApiKeysListPage />} />
              <Route path="new" element={<TenantApiKeyCreatePage />} />
              <Route path=":keyId" element={<TenantApiKeyDetailPage />} />
            </Route>
            <Route path="permissions" element={<TenantPermissionsPage />} />
            <Route path="settings" element={<TenantSettingsPage />} />
            <Route path="audit" element={<Outlet />}>
              <Route index element={<TenantAuditPage />} />
              <Route path=":logId" element={<TenantAuditLogDetailPage />} />
            </Route>
            <Route path="sessions" element={<Outlet />}>
              <Route index element={<TenantSessionsListPage />} />
              <Route path=":sessionId" element={<TenantSessionDetailPage />} />
            </Route>
            <Route path="support" element={<Outlet />}>
              <Route index element={<TenantSupportTicketsListPage />} />
              <Route path="new" element={<TenantSupportTicketFormPage />} />
              <Route path=":ticketId/edit" element={<TenantSupportTicketFormPage />} />
              <Route path=":ticketId" element={<TenantSupportTicketDetailPage />} />
            </Route>
            <Route path="system-settings" element={<Outlet />}>
              <Route index element={<TenantSystemSettingsListPage />} />
              <Route path="new" element={<TenantSystemSettingFormPage />} />
              <Route path=":settingId/edit" element={<TenantSystemSettingFormPage />} />
              <Route path=":settingId" element={<TenantSystemSettingDetailPage />} />
            </Route>
            <Route path="webhooks" element={<Outlet />}>
              <Route index element={<TenantWebhooksListPage />} />
              <Route path="new" element={<TenantWebhookFormPage />} />
              <Route path=":webhookId/edit" element={<TenantWebhookFormPage />} />
              <Route path=":webhookId" element={<TenantWebhookDetailPage />} />
            </Route>
            <Route path="export-jobs" element={<Outlet />}>
              <Route index element={<TenantExportJobsListPage />} />
              <Route path="new" element={<TenantExportJobFormPage />} />
              <Route path=":jobId" element={<TenantExportJobDetailPage />} />
            </Route>
            <Route path="plans" element={<Outlet />}>
              <Route index element={<TenantPlansPage />} />
              <Route path=":planId" element={<TenantPlanDetailPage />} />
            </Route>
            <Route path="subscription" element={<TenantSubscriptionPage />} />
            <Route path="features" element={<TenantFeaturesPage />} />
            <Route path="billing" element={<TenantBillingLayout />}>
              <Route index element={<TenantBillingProfilePage />} />
              <Route path="invoices" element={<Outlet />}>
                <Route index element={<TenantInvoicesListPage />} />
                <Route path=":invoiceId" element={<TenantInvoiceDetailPage />} />
              </Route>
            </Route>
            <Route path="knowledge-base" element={<TenantKnowledgeBaseLayout />}>
              <Route index element={<TenantKnowledgeArticlesListPage />} />
              <Route path="new" element={<TenantKnowledgeArticleFormPage />} />
              <Route path=":articleId/edit" element={<TenantKnowledgeArticleFormPage />} />
              <Route path=":articleId" element={<TenantKnowledgeArticleDetailPage />} />
            </Route>
            <Route path="notification-templates" element={<TenantNotificationTemplatesLayout />}>
              <Route index element={<TenantNotificationTemplatesListPage />} />
              <Route path="new" element={<TenantNotificationTemplateFormPage />} />
              <Route path=":templateId/edit" element={<TenantNotificationTemplateFormPage />} />
              <Route path=":templateId" element={<TenantNotificationTemplateDetailPage />} />
            </Route>
          </Route>
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/violation-uat" element={<ViolationUatPage />} />
          <Route path="/widget-demo" element={<ProctoringWidgetDemo />} />
          <Route path="/login" element={<FaceLogin />} />
          <Route path="/register" element={<RegistrationPage />} />
          <Route path="/" element={<SecureExamGate><DemoAssessment /></SecureExamGate>} />
        </Routes>
        </PlatformAuthProvider>
      </TenantAuthProvider>
    </Router>
  );
}

export default App;
